import type { PresetHOC } from '../types/PresetHOC';

export const withHideVisibilitySection: PresetHOC<{
    hideVisibilitySection?: boolean;
}> = (Item) => {
    Item.hideVisibilitySection = true;

    return Item;
};
